// src/pages/AddPrepItem.jsx
import React, { useState } from "react";
import { db, storage } from "./firebase/firebaseConfig";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";

const Wrapper = styled.div`
  padding: 40px;
  color: #fff;
`;

// Inputs
const Input = styled.input`
  width: 100%;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 6px;
  border: none;
  background: #1a1a1a;
  color: #fff;
`;

const Select = styled.select`
  width: 100%;
  padding: 12px;
  margin-bottom: 15px;
  border-radius: 6px;
  background: #1a1a1a;
  color: #fff;
`;

const Button = styled.button`
  padding: 12px 18px;
  background: linear-gradient(135deg, #00d4ff, #00bcd4);
  border: none;
  border-radius: 8px;
  cursor: pointer;
  color: #121212;
  font-weight: bold;
`;

// Loader overlay
const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  color: #fff;
  font-size: 1.2rem;
`;

const Loader = styled.div`
  border: 5px solid rgba(255, 255, 255, 0.2);
  border-top: 5px solid #00d4ff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${spin} 1s linear infinite;
  margin-bottom: 15px;
`;

const AddPrepItem = () => {
  const { prepId } = useParams();
  const [type, setType] = useState("note");
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!title) {
      alert("⚠️ Title required");
      return;
    }

    setLoading(true);
    try {
      let fileURL = null;
      if (file) {
        const storageRef = ref(
          storage,
          `interviewPreps/${prepId}/${Date.now()}-${file.name}`
        );
        await uploadBytes(storageRef, file);
        fileURL = await getDownloadURL(storageRef);
      }

      await addDoc(collection(db, `interviewPreps/${prepId}/items`), {
        type,
        title,
        content,
        fileURL,
        createdAt: serverTimestamp(),
      });

      alert("✅ Resource added!");
      navigate(`/interview-prep/${prepId}`);
    } catch (err) {
      console.error(err);
      alert("❌ Error uploading resource");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      <h2>Add Resource to Prep</h2>

      <Select value={type} onChange={(e) => setType(e.target.value)}>
        <option value="video">Video</option>
        <option value="question">Question</option>
        <option value="note">Note</option>
        <option value="topic">Topic</option>
      </Select>

      <Input
        type="text"
        placeholder="Title"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
      />

      {type !== "video" && (
        <Input
          type="text"
          placeholder="Content / Description"
          value={content}
          onChange={(e) => setContent(e.target.value)}
        />
      )}

      {type === "video" && (
        <Input
          type="file"
          accept="video/*"
          onChange={(e) => setFile(e.target.files[0])}
        />
      )}

      <Button onClick={handleSubmit}>Save</Button>

      {loading && (
        <Overlay>
          <Loader />
          Uploading, please wait...
        </Overlay>
      )}
    </Wrapper>
  );
};

export default AddPrepItem;
